function nominate() {
  let nominations = document.querySelectorAll('[data-nomination]');
  if (nominations.length) {

    const nominateForm = document.querySelector('.gform_nominate');
    const formAwards = nominateForm.querySelectorAll('.gfield--award .gchoice');

    nominations.forEach(function(award) {
      award.addEventListener('click', (event) => {

        //Remove class from all awards
        nominations.forEach(function(award) {
          award.classList.remove('checked');
        });

        //Add class to clicked award
        award.classList.add('checked');

        //Get award title
        const awardTitle = award.textContent;

        //Check the matching radio button
        formAwards.forEach(function(formAward) {
          formAwardTitle = formAward.querySelector('label').textContent;
          if (formAwardTitle == awardTitle) {
            formAward.querySelector('input').click();
          }
        });

      });
    });
  }
}
